import {
  TableData,
  TableHeaderCategoryConfig,
} from "../../../../../components/tables/tableContext/TableContext";

export interface RecallClientBatchResult {
  clientPlId: number;
  pharmacyName: string;
  status:
    | "waiting"
    | "processing"
    | "success"
    | "error"
    | "pending"
    | "unknown"
    | "skipped";
  detail?: string;
}

export const recallClientBatchTableHeader: TableHeaderCategoryConfig[] = [
  { value: "pharmacyName", label: "Farmacie", minW: 200 },
  { value: "status", label: "Rezultat", minW: 170 },
  { value: "detail", label: "Detalii", minW: 200 },
];

const statusLabels = {
  waiting: "In asteptare",
  processing: "Se proceseaza",
  success: "Finalizat",
  error: "Eroare",
  pending: "Solicitare in curs",
  unknown: "Rezultat neconfirmat",
  skipped: "Omis",
};

export const getRecallClientBatchTableData = (
  results: RecallClientBatchResult[],
  isFinished: boolean,
): TableData[] =>
  results.map((item) => ({
    id: item.clientPlId,
    crudData: item,
    data: [
      { title: item.pharmacyName },
      {
        badges: [
          {
            badgeText:
              isFinished && item.status === "waiting"
                ? "Neprocesat"
                : statusLabels[item.status],
            badgeColor:
              item.status === "success"
                ? "light-success"
                : item.status === "error" || item.status === "unknown"
                ? "light-danger"
                : "light-info",
          },
        ],
      },
      { title: item.detail ?? "-" },
    ],
  }));
